import type { FigmaIconProps } from './types';

export const IconFigmaCheckCircle = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
      stroke={color}
      strokeWidth="1.33333"
    />
    <path
      d="M5.33333 8.33333L7 10L10.6667 6.33333"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
